import { appointmentEpic as epic } from "./epic";
import { appointmentReducer as reducer } from "./reducer";

export const appointmentEpic = epic
export const appointmentReducer = reducer
